import '@styles/common/tailwind.css';
import '@styles/main.scss';
import MenuBar from './components/menu';
import CategoryAccordion from './components/category-accordion';
import HomepageSlides from './components/homepage-slides';
import ProductCategoryFilter from './components/product-category-filter';
import ProductSwatches from './components/product-swatches';
import NewArrivalsSwiper from './components/new-arrivals-swiper';
import MobileMenu from './components/mobile-menu';
import HomepageMobileSlider from './components/homepage-mobile-slider';

class App {
    constructor() {
        new MenuBar();
        new CategoryAccordion();
        new HomepageSlides();
        new ProductCategoryFilter();
        new ProductSwatches();
        new NewArrivalsSwiper();
        new MobileMenu();
        new HomepageMobileSlider();

        this.searchForm();

        const labels = document.querySelectorAll('.woof_checkbox_label') as NodeListOf<HTMLElement>;

        labels.forEach((label) => {
            if (label.innerText.includes('(0)')) {
                if (label.parentElement) {
                    label.parentElement.style.display = 'none';
                }
            }
        });
    } 

    searchForm() {
        const trigger = document.querySelector('.solo-search-link')
        const overlay = document.getElementById('search-overlay')
        const form = document.querySelector('.search-form');

        if(form === null) return;
        if(overlay === null) return;
        if(trigger === null) return;

        trigger.addEventListener('click', e => {
            e.preventDefault();

            overlay.classList.remove('is-hidden');
        })    

        overlay.addEventListener('click', () => overlay.classList.add('is-hidden'));

        form.addEventListener('click', e => e.stopPropagation());
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new App();
});